import {Injectable} from '@angular/core';
import {Message} from "../model/message.component";
import {map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class ViewManagerService {

  private FRONTENDS: {name: string, icon: string}[] = [
    {"name": "api", "icon": "bi-arrow-left-right"},
    {"name": "batch", "icon": "bi-box"},
    {"name": "realtime", "icon": "bi-clock"},
    {"name": "nlp", "icon": "bi-eye"},
    {"name": "ocr", "icon": "bi-eye"},
    {"name": "ai", "icon": "bi-cpu"},
  ]

  private langs = `{
    "English": "en",
    "Français": "fr",
    "Românǎ": "ro"
  }`;

  currentFrontends: {name: string, icon: string}[] = []

  languages = JSON.parse(this.langs)

  language: string = "en"

  messages: Message[] = new Array<Message>();

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private router: Router,
  ) {
  }

  switchContext() {

  }

  healthCheck(prefix: string) {
    return this.http.get<any>(prefix + "/health", {})
      .pipe(map(result => {
        return result;
      }));
  }

  cleanMessages() {
    this.messages = [];
  }

  displayMessage(message: Message, timeout = 3000) {
    this.messages.push(message);
    switch (message.level?.value) {
      case "error": {
        if (timeout < 10000) {
          timeout = 10000;
        }
        break;
      }
      case "warning": {
        if (timeout < 5000) {
          timeout = 5000;
        }
        break;
      }
      default: {
        if (timeout < 3000) {
          timeout = 3000;
        }
        break;
      }
    }
    let self = this;
    setTimeout(function () {
      const index = self.messages.indexOf(message, 0);
      if (index > -1) {
        self.messages.splice(index, 1);
      }
    }, timeout);
  }

  navigate(views: any[], state = {}) {
    this.router.navigate(views, state)
      .then((success) => {
        if (success) {
          console.log('Navigation successful');
        } else {
          console.log('Navigation failed');
        }
      })
      .catch((error) => {
        console.error('Navigation error:', error);
      });
  }

  getLanguages() {
    return Object.keys(this.languages);
  }

  getLanguage() {
    return this.language;
  }

  setLanguage(language: string) {
    if (Object.keys(this.languages).indexOf(language) > -1) {
      this.language = this.languages[language]
      this.translate.use(this.language);
    }
  }

  setFrontends(frontends: string[]) {
    this.currentFrontends = this.FRONTENDS.filter(front => frontends.includes(front.name))
  }

}
